/* global VARS */
/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'auth.pageTitle',
    defaultMessage: 'Claims Login',
  },
  policyNumber: {
    id: 'auth.policyNumber',
    defaultMessage: VARS.MESSAGE.auth.policyNumber,
  },
  emailId: {
    id: 'auth.emailId',
    defaultMessage: 'Email ID',
  },
  login: {
    id: 'auth.login',
    defaultMessage: 'Log in >',
  },
  proceed: {
    id: 'auth.proceed',
    defaultMessage: 'Next >',
  },
  loginFail: {
    id: 'auth.loginFail',
    defaultMessage: 'Oops, the policy number or the email doesn\'t exist in the system. This can happen if the policy number or an email is entered incorrectly or isn\'t registered on the policy. Please try entering again or ask the policyholder to add your email address to the policy via {portalLink}. Once completed, you can come back here to log in and submit your claim.',
  },
  loginFailAu: {
    id: 'auth.loginFailAu',
    defaultMessage: 'Oops, the policy number or the email doesn\'t exist in the system. This can happen if the policy number or an email is entered incorrectly or isn\'t registered on the policy. Please try entering again or ask the policyholder to add your email address to the policy via {portalLink}. Once completed, you can come back here to log in and submit your claim.',
  },
  loginFailNz: {
    id: 'auth.loginFailNz',
    defaultMessage: 'Oops, the policy number or the email doesn\'t exist in the system. This can happen if the policy number or an email is entered incorrectly or isn\'t registered on the policy. Please try entering again or ask the policyholder to add your email address to the policy via {portalLink}. Once completed, you can come back here to log in and submit your claim.',
  },
  loginFailPi: {
    id: 'auth.loginFailPi',
    defaultMessage: VARS.MESSAGE.authLoginFailPi.loginFail,
  },
  verificationCodeFail: {
    id: 'auth.verificationCodeFail',
    defaultMessage: 'The entered verification code is incorrect.',
  },
  verificationEmailSent: {
    id: 'auth.verificationEmailSent',
    defaultMessage: 'Your details are being verified and we will send you an email with a 6 digit verification code. Please enter the code below.',
  },
  reset: {
    id: 'auth.reset',
    defaultMessage: 'Reset',
  },
  instruction: {
    id: 'auth.instruction',
    defaultMessage: VARS.MESSAGE.authInstruction.instruction,
  },
  findYourPolicyNumber: {
    id: 'auth.FindYourPolicyNumber',
    defaultMessage: VARS.MESSAGE.authFindYourPolicyNumber.findYourPolicyNumber,
  },
  emailAddress: {
    id: 'auth.emailAddress',
    defaultMessage: 'Email Address',
  },
  isRequired: {
    id: 'auth.isRequired',
    defaultMessage: '{defaultMessage} is required',
  },
  policyDateValidationError: {
    id: 'auth.policyDateValidationError',
    defaultMessage: 'FNOL submission is only available for policies purchased on or after {purchaseDate}.',
  },
  emailAddressUsedToPurchasePolicy: {
    id: 'auth.emailAddressUsedToPurchasePolicy',
    defaultMessage: 'Email address used to purchase policy',
  },
  verificationCode: {
    id: 'auth.verificationCode',
    defaultMessage: 'Verification Code',
  },
  verificationCodePl: {
    id: 'auth.verificationCodePl',
    defaultMessage: 'Verification Code (e.g. 002200)',
  },
  portalLinkFallback: {
    id: 'auth.portalLinkFallback',
    defaultMessage: 'the customer portal',
  },
});



// WEBPACK FOOTER //
// ./app/containers/Login/messages.js